import {
  NB_WIDTH_TABLE_FEMALE,
  NB_WIDTH_TABLE_MALE,
} from './newBalanceWidthTable.constant';

export const NewBalanceSizeGrid = () => {
  return (
    <div className={'w-full'}>
      <div className={'w-full'}>
        <div
          className={
            'bg-primary text-white h-[45px] font-[500] text-[19px] flex items-center justify-center'
          }
        >
          Ширина обуви у мужчин
        </div>
        <div className="flex flex-nowrap w-full items-stretch content-center flex-row justify-start">
          <div className="overflow-scroll w-full">
            <table className="w-full border-collapse">
              <tbody>
                <tr>
                  {NB_WIDTH_TABLE_MALE.map((item) => (
                    <td
                      key={'male_code' + item.code}
                      className={
                        'p-2 text-center whitespace-nowrap border border-gray-200 font-normal'
                      }
                    >
                      {item.code}
                    </td>
                  ))}
                </tr>
                <tr>
                  {NB_WIDTH_TABLE_MALE.map((item) => (
                    <td
                      key={'male_value' + item.code}
                      className={
                        'p-2 text-center whitespace-nowrap border border-gray-200 font-normal'
                      }
                    >
                      {item.description}
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className={'w-full mt-[35px]'}>
        <div
          className={
            'bg-primary text-white h-[45px] font-[500] text-[19px] flex items-center justify-center'
          }
        >
          Ширина обуви у женщин
        </div>
        <div className="flex flex-nowrap w-full items-stretch content-center flex-row justify-start">
          <div className="overflow-scroll w-full">
            <table className="w-full border-collapse">
              <tbody>
                <tr>
                  {NB_WIDTH_TABLE_FEMALE.map((item) => (
                    <td
                      key={'female_code' + item.code}
                      className={
                        'p-2 text-center whitespace-nowrap border border-gray-200 font-normal'
                      }
                    >
                      {item.code}
                    </td>
                  ))}
                </tr>
                <tr>
                  {NB_WIDTH_TABLE_FEMALE.map((item) => (
                    <td
                      key={'female_value' + item.code}
                      className={
                        'p-2 text-center whitespace-nowrap border border-gray-200 font-normal'
                      }
                    >
                      {item.description}
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
